import { Modal } from '@hotpot-arcade/ui-components';
import simplifiedFtueImage from '../images/simplified-ftue.png';

type FtueProps = {
  onClose: () => void;
};

export function SimplifiedFtue({ onClose }: FtueProps) {
  return (
    <Modal
      onClose={onClose}
      footer={
        <button
          className="bg-customgreen text-customdarkgray rounded-3xl w-full p-3 font-bold transform transition duration-300 ease-out hover:scale-[1.03]"
          onClick={onClose}
        >
          Play Now
        </button>
      }
      className="!rounded-3xl !p-7"
    >
      <div className="flex flex-col justify-center items-center">
        <img src={simplifiedFtueImage} className="w-[86px] mb-2" />
        <div className="text-center space-y-3 mt-6 mb-2">
          <h1 className="text-dark-1 font-bold text-xl">Play and Bond in FanForge</h1>
          <p className="text-dark-1">
            Game together with other members of your community. Team up and start chasing those high scores!
          </p>
        </div>
      </div>
    </Modal>
  );
}
